import React from 'react'
import _ from 'lodash'

import BkFlowMaterialLoader  from '../../../elements/BkFlowMaterialLoader'
import BkFlowSideBarPolicyEntries from './elements/BkFlowSidebarPolicyEntries'

const BkFlowSidebarPolicies = props => {
  const {
    configData,
    availabilityLoading,
    activeRoom,
    roomRateDetailsData,
    activeHotelCode,
  } = props

  const hotelLabels = configData.hotel.labels[0]
  let renderPolicies = null

  if (
    availabilityLoading ||
    roomRateDetailsData.loading
  ) {
    renderPolicies = (
      <BkFlowMaterialLoader
        parentClasses='u-txt-center'
        size={30}
      />
    )
  } else {
    if (activeRoom) {
      let renderRoomPolicies = [],
          roomPoliciesData,
          totalRooms = Object.keys(activeRoom).length

      for (let roomKey in activeRoom) {
        // check initial availabilityData OR additional roomRateDetailsData for cancel policies
        if (!_.isEmpty(activeRoom[roomKey][1][0].viewExtensions.policies)) {
          roomPoliciesData = activeRoom[roomKey][1][0].viewExtensions.policies
        } else if (
          roomRateDetailsData &&
          roomRateDetailsData.roomRateDetails &&
          roomRateDetailsData.roomRateDetails[activeRoom[roomKey][1][0].roomTypeCode + '-' + activeRoom[roomKey][1][0].ratePlanCode + '-' + roomKey] &&
          !_.isEmpty(roomRateDetailsData.roomRateDetails[activeRoom[roomKey][1][0].roomTypeCode + '-' + activeRoom[roomKey][1][0].ratePlanCode + '-' + roomKey].viewExtensions.policies)
        ) {
          roomPoliciesData = roomRateDetailsData.roomRateDetails[activeRoom[roomKey][1][0].roomTypeCode + '-' + activeRoom[roomKey][1][0].ratePlanCode + '-' + roomKey].viewExtensions.policies
        }

        if (activeHotelCode === 'B5B0') {
          // SBE100-2710: hard coded converting from 300 AED for daily deposit, remove once a dynamic solution is found
          const policyDescription = 'A security deposit of AED 300 per night applies for stays until 30th September 2025, and AED 500 per night for stays from 1st October to 31st December 2025. The deposit will be collected upon arrival, either by credit card or cash. Cash deposits will be reimbursed at check-out, while credit card holds will be released approximately 14 days after check-out.'
          const depositPolicy = {
            '@type': 'Description',
            'caption': null,
            'name': 'Deposit Policy',
            'text': policyDescription
          }

          roomPoliciesData.push(depositPolicy)
        }

        // construct a policies group for each activeRoom
        if (!_.isEmpty(roomPoliciesData)) {
          renderRoomPolicies.push(
            <div
              className="bk-flow-payment__sidebar-policies-group"
              key={ activeRoom[roomKey][1][0].roomTypeCode + '-' + activeRoom[roomKey][1][0].ratePlanCode + '-' + roomKey + '-policies' }
            >
              { totalRooms > 1 ?
                <p className="u-remove-margin u-font-bold">{ hotelLabels.room ? hotelLabels.room : 'Room' } { Number(roomKey) + 1 } { hotelLabels.policies ? hotelLabels.policies : 'Policies'}</p>
              :
                <p className="u-remove-margin u-font-bold">{ hotelLabels.roomPolicies ? hotelLabels.roomPolicies : 'Room Policies' }</p>
              }
              <BkFlowSideBarPolicyEntries
                roomPolicies={roomPoliciesData}
              />
            </div>
          )
        }
      }

      // construct policies block(s) based on policies groups being set from activeRoom(s)
      if (!_.isEmpty(renderRoomPolicies)) {
        renderPolicies = (
          <div className="bk-flow-payment__sidebar-policies">
            <div className="bk-flow-payment__sidebar-policies-content">
              { renderRoomPolicies }
            </div>
          </div>
        )
      }
    }
  }

  return renderPolicies
}

export default BkFlowSidebarPolicies



// WEBPACK FOOTER //
// ./src/components/payment/sidebar/policies/BkFlowSidebarPolicies.js